import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter } from 'react-router-dom';

import Navbar from './components/TopBar';
import { ErrorBoundary } from './components';
import { AlertError } from './components/ErrorMessage';

import { activateGoogleOptimize } from './redux/actions/analyticsEventActions';
import {
  initUserInfo,
  loginSessionExpire,
  storeToken,
} from './redux/actions/authActions';
import { setUpSentry } from './config';
import { inProduction, isUserLoggedIn } from './lib/utils';

import Footer from './components/Footer';
import LoginContainer from './redux/containers/LoginContainer';
import SessionExpire from './screens/LoginSessionExpire';
import FlightsScreen from './screens/Flights';
import ScrollToTopOnMount from './components/ScrollToTopOnMount';

import './scss/App.css';

type Props = {
  storeToken: () => void,
  initUserInfo: () => void,
  loginSessionExpire: () => void,
  activateGoogleOptimize: () => void,
};

class App extends Component<Props> {
  componentDidMount() {
    this.init();
    this.props.activateGoogleOptimize();
  }

  init = () => {
    
    if (inProduction()) setUpSentry();
    
    if (isUserLoggedIn()) {
      const { initUserInfo, storeToken } = this.props;
      const { token, roles, id } = localStorage;
      
      storeToken(token, roles, id);
      initUserInfo();
    }
  };

  componentWillUnmount() {
    this.clearTimeouts();
  }

  isLandingPage = props => props.location.pathname === '/';

  dontRenderInLandingPage = (Component, props) =>
    this.isLandingPage(props) ? null : <Component />;

  render() {
    return (
      <div className="App">
        <ErrorBoundary errorInAppLevel>
          <Route
            path="/"
            render={props => this.dontRenderInLandingPage(Navbar, props)}
          />

          <LoginContainer />
          <SessionExpire />
          <AlertError />
          <ScrollToTopOnMount />

          <Switch>
            <Route
              path="/flights/all"
              component={FlightsScreen}
            />

            <Route
              path="/flights/pokhara-to-jomsom-online-flight-booking"
              component={FlightsScreen}
            />

            <Route
              path="/flights/ramechhap-to-lukla-online-flight-booking"
              component={FlightsScreen}
            />

            {/* <Route
              path="/flights/kathmandu-to-pokhara-online-flight-booking"
              component={FlightsScreen}
            /> */}
            
            <Route
              path="/flights"
              component={FlightsScreen}
            />

          </Switch>
          {/* <Route
            render={props => (this.isLandingPage(props) ? null : <Error404 />)}
          /> */}
          <Footer />
        </ErrorBoundary>
      </div>
    );
  }
}

export default withRouter(
  connect(
    null,
    {
      storeToken,
      initUserInfo,
      loginSessionExpire,
      activateGoogleOptimize,
    }
  )(App)
);



// WEBPACK FOOTER //
// ./src/App.js